import React from "react"
import Report from "./Report"
import GridContainer from "../../components/Grid/GridContainer.jsx"
import GridItem from "../../components/Grid/GridItem.jsx"
import ChannelsSelector from "./ChannelsSelector"
import PeriodsSelector from "./PeriodsSelector"
import { componentWithContext } from "../../state/DispatchContext"
import { getPeriod, refreshAllReports } from "../../state/helpers"
import backend from "../../utils/backend"
import CDNReport from "./CDNReport.jsx"

class CenteredTabs extends React.Component {
  state = {
    cdnData: null,
    systemId: null,
    from: null,
    to: null,
  }

  handleDatePickerChange = () => {
    const [m1, m2] = getPeriod(this.props.context, 1)

    this.setState({
      from: m1.unix(),
      to: m2.unix(),
    })
  }

  componentDidMount = async () => {
    try {
      await refreshAllReports(this.props.context)
      const systemId = this.props.context.state.systems.list.find((system) => system.type === "FastlyCDN").id

      this.handleDatePickerChange()

      const data = await backend.getCdnBandwidth(systemId, this.state.from, this.state.to)
      this.setState({ cdnData: data, systemId })
    } catch (ex) {
      console.error(ex)
    }
  }

  render() {
    const systems = this.props.context.state.systems.list || []

    return (
      <div>
        <GridContainer justify="flex-end">
          <GridItem>
            <PeriodsSelector />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem>
            <h4>Channel reports</h4>
          </GridItem>
        </GridContainer>
        <GridContainer justify="flex-end">
          <GridItem>
            <ChannelsSelector />
          </GridItem>
        </GridContainer>
        <GridContainer>
          {systems.map(
            (system) =>
              system.reports &&
              system.reports
                .filter((report) => report.channelDependent)
                .map((report) => {
                  return (
                    <Report
                      systemId={system.id}
                      reportName={report.reportName}
                      key={system.id + report.reportName}
                      disableTimingSelect={report.disableTimingSelect}
                      showCampaignSelector={report.showCampaignSelector}
                      useDashboard={false}
                    ></Report>
                  )
                }),
          )}
        </GridContainer>
        {this.state.cdnData && (
          <>
            <GridContainer>
              <GridItem>
                <h4>CDN reports</h4>
              </GridItem>
            </GridContainer>
            <GridContainer style={{ minWidth: "100%" }}>
              <CDNReport data={this.state.cdnData} />
            </GridContainer>
          </>
        )}
        <GridContainer>
          <GridItem>
            <h4>Asset reports</h4>
          </GridItem>
        </GridContainer>
        <GridContainer>
          {systems.map(
            (system) =>
              system.reports &&
              system.reports
                .filter((report) => !report.channelDependent)
                .map((report) => {
                  return (
                    <Report
                      systemId={system.id}
                      reportName={report.reportName}
                      key={system.id + report.reportName}
                      disableTimingSelect={report.disableTimingSelect}
                      showCampaignSelector={report.showCampaignSelector}
                      useDashboard={false}
                    ></Report>
                  )
                }),
          )}
        </GridContainer>
      </div>
    )
  }
}

export default componentWithContext(CenteredTabs)
